/** Status counters of the review step, in display order. `all` is not a row status. */
export const REVIEW_STATUS_FILTER = Object.freeze({
  ALL: 'all',
  NEW: 'new',
  UPDATE: 'update',
  ERROR: 'error',
});

export const ROW_STATUS = Object.freeze({ NEW: 'new', UPDATE: 'update', ERROR: 'error' });

/** Filter dropdowns: `id` is the key in `review.filters`, options carry a locale key. */
export const ACCESS_FILTER = Object.freeze({
  NONE: 'none',
  ASSIGNED: 'assigned',
  ADMIN: 'admin',
  NO_STUDIO: 'no_studio',
});
export const MISSING_FILTER = Object.freeze({
  ROLE: 'role',
  JOB_TITLE: 'job_title',
  LOCATION: 'location',
  MANAGER: 'manager',
});
export const CHECK_FILTER = Object.freeze({
  OUTSIDE_DOMAIN: 'outside_domain',
  POSSIBLE_DUPLICATE: 'possible_duplicate',
});

export const ISSUE = Object.freeze({
  INVALID_EMAIL: 'invalid_email',
  UNKNOWN_ROLE: 'unknown_role',
  UNKNOWN_GROUP: 'unknown_group',
  REPORTS_TO_SELF: 'reports_to_self',
  REPORTING_LOOP: 'reporting_loop',
  OWNER_NOT_IMPORTABLE: 'owner_not_importable',
  OUTSIDE_DOMAIN: 'outside_domain',
  POSSIBLE_DUPLICATE: 'possible_duplicate',
});

/** Informative lines under a row's status: they never block it nor feed a filter. */
export const NOTE = Object.freeze({
  SUSPENDED_UPDATE: 'suspended_update',
  REPORTS_TO_UNKNOWN: 'reports_to_unknown',
});

/** Issues that block a row (the rest are warnings that only show up in filters/badges). */
export const BLOCKING_ISSUES = Object.freeze([
  ISSUE.INVALID_EMAIL,
  ISSUE.UNKNOWN_ROLE,
  ISSUE.UNKNOWN_GROUP,
  ISSUE.REPORTS_TO_SELF,
  ISSUE.REPORTING_LOOP,
  ISSUE.OWNER_NOT_IMPORTABLE,
]);

export const REVIEW_PAGE_SIZES = Object.freeze([25, 50, 100]);
export const DEFAULT_REVIEW_PAGE_SIZE = 25;
